export const CARDS_BLOCK_c12 = {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px",
    "background-image": "linear-gradient(to right,,)"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 80px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 60px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 50px 0px"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 0,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "margin": "0px 0px 20px 0px",
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "color": "",
        "font-weight": "500",
        "opacity": "1",
        "text-align": "left"
      },
      "stylePropsTab": {
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "1px 0px 0px 0px"
      },
      "renderHTML": true
    },
    {
      "type": "text",
      "id": 1747230478697,
      "elIndex": 1,
      "text": "[[description]]",
      "location": "B",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "styleProps": {
        "margin": "0px 0px 0px 0px",
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    },
    {
      "type": "text",
      "id": 1747242499486,
      "elIndex": 2,
      "text": "[[department]]",
      "location": "B",
      "params": [
        {
          "value": "department",
          "label": "department"
        }
      ],
      "styleProps": {
        "margin": "10px 0px 0px 0px",
        "opacity": "1",
        "background-color": "",
        "color": "#ffa611"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 3,
      "text": "[[tags]]",
      "location": "B",
      "params": [
        {
          "value": "tags",
          "label": "tags"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "font-size": "0.875rem",
        "line-height": "1.25rem",
        "font-weight": "500",
        "margin": "0px 0px 0px 0px",
        "padding": "20px 0px 0px 0px",
        "display": "flex",
        "flex-wrap": "wrap"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "renderHTML": false,
      "csv": true,
      "csvElementStyleProps": {
        "background-color": "#116dff33",
        "color": "#333333",
        "margin": "0px 4px 4px 4px",
        "padding": "4px 14px 4px 14px",
        "border-radius": "1rem"
      }
    },
    {
      "type": "button",
      "id": 1747075505385,
      "elIndex": 4,
      "text": "View Profile",
      "location": "D",
      "params": [
        {
          "value": "status",
          "label": "status "
        }
      ],
      "styleProps": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "font-weight": "600",
        "background-color": "",
        "text-align": "center"
      },
      "btnStyleProps": {
        "border-width": "0px",
        "border-radius": "1rem",
        "background-color": "#ffffff",
        "padding": "14px 20px 14px 20px",
        "color": "#333333",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px",
        "width": "100%",
        "font-weight": "600",
        "box-shadow": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"
      }
    },
    {
      "type": "image",
      "id": 1747240881600,
      "elIndex": 5,
      "text": "",
      "location": "A",
      "params": {
        "value": "img",
        "label": "img"
      },
      "imageContent": "crop",
      "imgStyleProps": {
        "height": "320px",
        "width": "100%",
        "border-radius": "0.75rem"
      }
    },
    {
      "type": "text",
      "id": 1747242176041,
      "elIndex": 6,
      "text": "[[status ]]",
      "location": "C",
      "params": [
        {
          "value": "status",
          "label": "status "
        }
      ],
      "styleProps": {
        "background-color": "[[color]]",
        "display": "",
        "padding": "4px 10px 4px 10px",
        "border-radius": "0.375rem"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 1
    },
    "layout": "l4",
    "cardstyleProps": {
      "padding": "2px 2px 2px 2px",
      "border-width": "0px",
      "border-color": "#cccccc"
    },
    "cardstylePropsMob": {
      "padding": "2px 0px 2px 0px"
    },
    "cardstylePropsTab": {
      "padding": "2px 2px 2px 2px"
    },
    "alternate": false
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1747242554785
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1747241996883,
  "afterIndex": 10,
  "blockId": 1747241996883,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "linear-gradient(to right,,)",
        "border-radius": "1rem",
        "padding": "20px 20px 20px 20px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff",
        "box-shadow": "",
        "width": "none",
        "margin": "0px 0px 0px 0px",
        "color": "#333333",
        "border-width": "0px 0px 1px 0px",
        "border-color": "#cccccc"
      },
      "stylePropsTab": {
        "border-radius": "1rem",
        "width": "auto",
        "padding": "10px 10px 10px 10px"
      },
      "stylePropsMob": {
        "border-radius": "0.75rem",
        "width": "auto",
        "padding": "20px 20px 20px 10px"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "1rem",
        "padding": "0px 10px 0px 0px",
        "box-shadow": "",
        "alignItems": "",
        "justify-content": "center",
        "flex-direction": "column",
        "display": "flex",
        "width": "15%",
        "text-align": "left",
        "background-image": "linear-gradient(to right,,)",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover",
        "color": ""
      },
      "innerDiv": {
        "styleProps": {
          "height": "auto",
          "width": "auto",
          "border-radius": "50%",
          "background-image": "linear-gradient(to right,,)",
          "padding": "0px 0px 0px 0px",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": "",
          "background-color": ""
        },
        "stylePropsTab": {
          "height": "auto"
        },
        "stylePropsMob": {
          "height": "auto"
        }
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "width": "100%"
      },
      "stylePropsTab": {
        "width": "50%"
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "0px 20px 0px 20px",
        "display": "",
        "flex-direction": "column",
        "justify-content": "",
        "width": "45%",
        "alignItems": "center",
        "text-align": "left",
        "box-shadow": "",
        "border-radius": "1rem",
        "background-color": "",
        "background-image": "linear-gradient(to right,,)",
        "color": "",
        "border-width": "0px",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsTab": {
        "padding": "0px 10px 0px 10px",
        "width": "50%"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "width": "100%"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": "",
          "padding": "0px 0px 0px 0px",
          "border-width": "0px",
          "background-color": "",
          "box-shadow": ""
        },
        "stylePropsMob": {
          "width": "auto"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "25%",
        "display": "flex",
        "flex-direction": "",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center",
        "padding": "0px 10px 0px 10px"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": "",
          "background-color": "",
          "padding": "0px 0px 0px 0px"
        }
      },
      "stylePropsTab": {
        "width": "50%"
      },
      "stylePropsMob": {
        "width": "100%",
        "padding": "10px 0px 10px 0px"
      }
    },
    {
      "name": "D",
      "styleProps": {
        "width": "15%",
        "padding": "0px 10px 0px 10px"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "width": "100%"
      },
      "stylePropsTab": {
        "width": "50%"
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": "",
      "background-image": "linear-gradient(to right,,)"
    }
  },
  "containerStyleProps": {
    "max-width": "auto"
  },
  "cardLink": {
    "active": false
  }
}